// extracted by mini-css-extract-plugin
export default {"container":"CreateModuleSourceTab_container__CkJEy","editor-container":"CreateModuleSourceTab_editor-container__AKYp5"};